export default "__VITE_ASSET__2ee90f08__"